import EventEmitter from "./utils/EventEmitter";
import FontFaceObserver from 'fontfaceobserver'

export default class AccordionsPushes extends EventEmitter {
    constructor(element) {
        super();

        this.element = element;

        this.items = Array.from(this.element.querySelectorAll('.accordion-item'))
        this.imagesContainer = this.element.querySelector('.push-image-container')
        this.index = 0

        this.pushImagesInContainer()

        const font = new FontFaceObserver('Sora')

        font.load().then(() => {
            this.closeItems()
            this.openItem(0)
        })
    }

    pushImagesInContainer() {
        this.items.forEach((item) => {
            let image = item.querySelector('.image-holder img')
            if (image) {
                this.imagesContainer.appendChild(image)
            }
        })

        this.imagesContainerItems = Array.from(this.imagesContainer.querySelectorAll('img'))
        if (this.imagesContainerItems.length > 0) {
            this.imagesContainerItems[0].classList.add('active')
        }

        this.events()
    }

    events() {

        this.items.forEach((item, index) => {

            item.addEventListener('click', () => {
                // Si l'item n'est pas déjà ouvert on ferme tous les items et on ouvre celui cliqué
                if (!item.classList.contains('open')) {
                    this.closeItems()
                    this.openItem(index)
                    if (index !== this.index) {
                        this.updateImages(index)
                    }
                } else {
                    this.closeItems()
                }
            })
        })
    }

    openItem(index) {
        this.items[index].classList.add('open')
        this.items[index].style.height = `${this.items[index].querySelector('.accordion-content').getBoundingClientRect().height}px`
    }

    closeItems() {
        this.items.forEach((item) => {
            item.classList.remove('open')
            item.style.height = `${item.querySelector('.accordion-header').getBoundingClientRect().height}px`
        })
    }

    updateImages(index) {
        if (this.imagesContainerItems[index] === undefined) {
            return
        }
        this.imagesContainer.querySelector('.active').classList.add('leave')
        this.imagesContainer.querySelector('.active').classList.remove('active')

        this.imagesContainerItems[index].classList.add('active')
        setTimeout(() => {
            this.imagesContainerItems.forEach((image) => {
                image.classList.remove('leave')
            })
            this.index = index
        }, 850)
    }
}
